import { render, staticRenderFns } from "./CarStatistics.vue?vue&type=template&id=52438d77&scoped=true"
import script from "./CarStatistics.vue?vue&type=script&lang=js"
export * from "./CarStatistics.vue?vue&type=script&lang=js"
import style0 from "./CarStatistics.vue?vue&type=style&index=0&id=52438d77&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52438d77",
  null
  
)

export default component.exports